// 审批管理
export default {
    autoApprovalSettings: 'Auto Approval Settings',
    taskNumber: 'Task Number',
    approvalTime: 'Approval Time',
    approver: 'Approver',
    reasonFailure: 'Reason for failure',
    mapView: 'Map View',
    pass: 'Pass',
    fail: 'Fail',
    tip_pleaseEnterFail: 'Please enter the reason for failure',
    tip_surePass: 'Are you sure to pass?',
    warning1: 'The automatic approval function needs to take effect after setting.',
    warning2: 'After automatic approval is turned on, the approval submitted by users in the automatic approval list will be automatically passed, but the system will still record the task.',
    department: 'Department',
    username: 'User Name',
    phoneNumber: 'Phone Number',
    userManagement: 'User Management',
    role: 'Role',
    remove: 'Remove',
    bulkRemoval: 'Bulk Removal',
    tip_remove: 'Are you sure you want to remove?',
    autoApproval: 'Automatic Approval',
    userNotAdded: 'User not added',
    userAdded: 'User added',
    pleaseEnterUserName: 'please enter user name',
    viewTasks: 'View tasks',
    autoApprovalPeriod: 'Auto Approval Period',
    approvalTaskType: 'Approval Task Type',
    enterAutoApproval: 'Please enter an auto-approval period',
}